export default __webpack_public_path__ + "static/raquel-c2995308fa3cb16089bde4750c3ca5f4.png";